import { gql, useMutation } from '@apollo/client';
import { GqlError, formatErrors } from '../utils/errors';

const REFUND_MEMBER_EVENT_TICKET_MUTATION = gql`
  mutation refundMemberEventTicketMutation($id: Int!) {
    refundMemberEventTicket(ticketId: $id) {
      id
      amount
    }
  }
`;

const useRefundMemberEventTicket = (onCompleted) => {
  const [refundMemberEventTicketMutation, { loading, data, error }] = useMutation(
    REFUND_MEMBER_EVENT_TICKET_MUTATION,
    { onCompleted },
  );

  const refundMemberEventTicket = async ({ id }) => {
    try {
      const response = await refundMemberEventTicketMutation({
        variables: {
          id,
        },
      });
      return response.data.refundMemberEventTicket;
    } catch (e) {
      const formattedErrors = formatErrors(e);
      throw new GqlError({
        name: 'Ticket Refund Error',
        errors: formattedErrors,
      });
    }
  };

  return [
    refundMemberEventTicket,
    {
      loading,
      data,
      error: error ? formatErrors(error) : null,
    },
  ];
};

export default useRefundMemberEventTicket;
